import createChatSlice, { initialState } from '@sv-support-sdk/chat-store/src/modules/chat/slices';
import { resetState } from '@sv-support-sdk/chat-store/src/modules/reset/actions';

export const chatSlice = createChatSlice({
  initialState: { ...initialState },
  reducers: {},
  resetState,
});

export const {
  setChatOpen,
  setPopup,
  setUserBan,
  setChatData,
  setChatSettings,
  addSupport,
  setSupports,
  setChatCompany,
} = chatSlice.actions;

export default chatSlice.reducer;
